import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { useIsMobile } from '@/hooks/use-mobile';

interface ProfileAvatarProps {
  src?: string | null;
  name?: string | null;
  size?: 'sm' | 'md';
  className?: string;
}

function getInitials(name: string | null | undefined): string {
  if (!name) return '?';
  return name.split(' ').map(w => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
}

const SIZE_CLASSES = {
  sm: 'w-7 h-7',
  md: 'w-8 h-8',
} as const;

export function ProfileAvatar({ src, name, size, className }: ProfileAvatarProps) {
  const isMobile = useIsMobile();
  const resolvedSize = size ?? (isMobile ? 'sm' : 'md');

  return (
    <Avatar className={cn('flex-shrink-0', SIZE_CLASSES[resolvedSize], className)}>
      <AvatarImage src={src || undefined} alt={name || 'Avatar'} />
      <AvatarFallback className="text-[8px] bg-secondary text-muted-foreground">
        {getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
